module.exports = __webpack_public_path__ + "931cce941c28de3d1562f5aa81130e6f.woff2";